<div
  class="switch-group-container"
  [attr.data-size]="size()"
  [attr.data-layout]="layout()"
  [attr.data-disabled]="isDisabled()"
  [attr.data-full-width]="fullWidth()"
  [attr.data-switch-position]="switchPosition()"
>
  @if (switchPosition() === 'Left') {
    <umss-switch
      [checked]="checkedValue()"
      [disabled]="isDisabled()"
      [size]="size()"
      [ariaLabel]="computedAriaLabel()"
      (checkedChange)="onSwitchChange($event)"
    >
    </umss-switch>
  }

  <div class="switch-group-content">
    <umss-label
      [text]="label()"
      [required]="required()"
      size="Regular"
      weight="Medium"
    >
    </umss-label>

    @if (helperText()) {
      <p class="switch-group-helper">
        {{ helperText() }}
      </p>
    }
  </div>

  @if (switchPosition() === 'Right') {
    <umss-switch
      [checked]="checkedValue()"
      [disabled]="isDisabled()"
      [size]="size()"
      [ariaLabel]="computedAriaLabel()"
      (checkedChange)="onSwitchChange($event)"
    >
    </umss-switch>
  }
</div>
